// The class names the Email & Templates page and its popups share, taken from
// the existing settings page so light and dark mode match the rest of the site.
export const emailSettingsStyles = isLight => ({
	text: isLight ? 'text-gray-900' : 'text-white',
	muted: isLight ? 'text-gray-500' : 'text-gray-400',
	label: `block text-xs font-medium mb-1 ${isLight ? 'text-gray-600' : 'text-gray-400'}`,
	sectionTitle: `text-xs font-semibold uppercase tracking-wide mb-2 ${isLight ? 'text-gray-400' : 'text-gray-500'}`,
	card: `p-4 rounded-lg border ${isLight ? 'bg-gray-50 border-gray-200' : 'bg-[#263340] border-[#374151]'}`,
	divider: isLight ? 'border-gray-200' : 'border-[#374151]',
	input: `w-full px-2.5 py-1.5 text-sm rounded-md focus:outline-none focus:ring-2 focus:ring-[#1d9bf0] ${
		isLight
			? 'bg-white ring-1 ring-gray-300 text-gray-900 placeholder-gray-400'
			: 'bg-[#1a2634]/60 ring-1 ring-white/10 text-white placeholder-gray-500'
	}`,
	primaryButton: 'px-4 py-2 rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed',
	secondaryButton: `px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
		isLight ? 'text-gray-700 bg-gray-100 hover:bg-gray-200' : 'text-gray-300 bg-[#374151] hover:bg-[#4B5563]'
	}`,
	iconButton: `shrink-0 p-1.5 rounded ${isLight ? 'text-gray-400 hover:text-gray-700 hover:bg-gray-100' : 'text-gray-500 hover:text-gray-200 hover:bg-white/10'}`,
	errorBox: `px-4 py-3 rounded-lg text-sm ${isLight ? 'bg-red-500/10 text-red-600' : 'bg-red-500/10 text-red-400'}`,
	chip: `px-2.5 py-1 rounded-md font-mono text-xs transition-colors ${
		isLight ? 'bg-blue-50 text-blue-700 hover:bg-blue-100' : 'bg-blue-500/10 text-blue-300 hover:bg-blue-500/20'
	}`,
})
